module.exports = __webpack_public_path__ + "static/media/Video.5bfa1fa6.svg";